import React from 'react';
import './Blog.css';

const Blog = () => {
  return (<>
      <div className="blog-header">
      </div>
      <div className="blog-content">
        <div className="blog-placeholder">
          <h3>הולך להיות כאן דברים
</h3>
          <h2>ממש מעניינים
</h2>
<h3>...תעקבי</h3>
        </div>
      </div>
      </>
  );
};

export default Blog;